export default __webpack_public_path__ + "static/media/deer.10fedc5c.png";